
export const HELPDESK_BASE_URL = process.env.REACT_APP_HELPDESK_BASE_URL;

export const HELPDESK_TENANT_ID = '7698a247-5850-45b5-92e4-848f2bf72d67';

export const HELPDESK_TYPE_ID = 'a95df7f5-70fe-4b89-b115-442c83952bad';

// Departments the CRM Help Desk can raise tickets against. These are pinned by
// id rather than looked up by name because "CRM internal" is a CHILD department
// (parent_id = "Prop Tech") and is flagged is_internal -- getAllLevelOneDepartments
// only returns top-level departments, so it can never return it.
//
// TO ADD A DEPARTMENT: append { id, name } below and it appears in the dropdown.
// Take the `id` and `name` straight from the helpdesk `departments` table row.
// The first entry is the default selection.
export const CRM_DEPARTMENTS = [
  { id: 'd2cf2aaa-390f-433c-99f9-4449220d8ebb', name: 'CRM internal' },
];

// Default / first department.
export const CRM_DEPARTMENT = CRM_DEPARTMENTS[0];

// Kept for backward compatibility with existing imports.
export const CRM_DEPARTMENT_NAME = CRM_DEPARTMENT.name;


export const buildHelpDeskUser = (loggedInUser) => {
  const rawMobile = loggedInUser?.contactNumber
    ? String(loggedInUser.contactNumber)
    : '';
  return {
    name: loggedInUser?.name || '',
    email: loggedInUser?.email || '',
    mobile: rawMobile ? rawMobile.slice(-10) : '',
    crmUserId: loggedInUser?.userId || '',
  };
};
